export const isSafari = () => {
  if (typeof navigator === 'undefined') return false;
  const userAgent = navigator.userAgent;

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Browser_detection_using_the_user_agent#browser_name_and_version
  return (
    userAgent.includes('Safari') && !userAgent.includes('Chrome') && !userAgent.includes('Chromium')
  );
};

export function isFirefox() {
  if (typeof navigator === 'undefined') return false;
  const userAgent = navigator.userAgent;

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Browser_detection_using_the_user_agent#browser_name_and_version:~:text=Must%20not%20contain-,Firefox,Seamonkey/xyz,-Seamonkey
  return userAgent.includes('Firefox/') && !userAgent.includes('Seamonkey/');
}

export const getWindow = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window;
};

// SSR-safe: the browser origin on the client, '' on the server.
export const getWindowOrigin = () => getWindow()?.location.origin ?? '';
